import { EntityPdfField } from './types';

export const getLabelWidth = (fields: EntityPdfField[]) => {
  const maxChars = Math.max(...fields.map((field) => field.label?.length ?? 0));
  const CHAR_WIDTH = 7.2;

  return Math.min(maxChars * CHAR_WIDTH + 8, 260);
};
